import { render, staticRenderFns } from "./UploadTest.vue?vue&type=template&id=45857435&lang=pug&"
import script from "./UploadTest.vue?vue&type=script&lang=js&"
export * from "./UploadTest.vue?vue&type=script&lang=js&"
import style0 from "./UploadTest.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports